module.exports = __webpack_public_path__ + "static/media/survey-reports-slider-2x.eba71c16.jpg";